import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = 'cfr_region_gate';

export const RegionGate = ({ children }) => {
  const [blocked, setBlocked] = useState(() => sessionStorage.getItem(KEY) === 'blocked');
  useEffect(() => {
    if (blocked || sessionStorage.getItem(KEY) === 'ok') return;
    fetch(`${API}/api/geo/gate`).then((r) => r.json()).then((d) => {
      sessionStorage.setItem(KEY, d.blocked ? 'blocked' : 'ok');
      if (d.blocked) setBlocked(true);
    }).catch(() => {});
  }, [blocked]);
  if (!blocked) return children;
  return (
    <main data-testid="region-blocked" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#F6F1E8', color: '#1F2A44', padding: '2rem', fontFamily: 'var(--font-body, sans-serif)' }}>
      <div style={{ maxWidth: 520, textAlign: 'left' }}>
        <p style={{ margin: '0 0 0.75rem', fontSize: '0.8rem', letterSpacing: '0.12em', textTransform: 'uppercase', fontWeight: 700, color: '#8A5A3C' }}>Christian Family Recovery</p>
        <h1 style={{ margin: '0 0 1rem', fontSize: 'clamp(1.6rem, 4vw, 2.2rem)', lineHeight: 1.15 }}>This site isn’t available in your region.</h1>
        <p data-testid="region-blocked-message" style={{ margin: 0, lineHeight: 1.65, color: '#1F2A44CC' }}>Christian Family Recovery is not available in your country at this time. Thank you for understanding.</p>
      </div>
    </main>
  );
};
